
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 135.3 135.3","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M127.1 71.8c0 10.6-1.2 20-3.6 30.6-3.6 15.3-14.2 25.9-29.7 29.4-20.2 4.7-41.6 4.7-61.7 0-14.2-3.5-26.1-15.3-28.5-29.4C1.2 91.8 0 81.2 0 71.8c0-10.6 1.2-20 3.6-30.6 3.6-15.3 14.2-25.9 29.7-29.4 9.5-2.4 20.2-3.5 30.9-3.5s20.2 1.2 30.9 3.5c15.4 3.5 26.1 14.1 29.7 29.4 1.1 9.4 2.3 20 2.3 30.6z","fill":"#80adfd"}}),_c('circle',{attrs:{"cx":"102.9","cy":"32.4","fill":"#005aff","r":"32.4"}})])
          )
        }
      }
    